import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { createNewJob } from '../../store/actions';

import BaseModal from '../../components/BaseModal';
import BaseAutocomplete from '../../components/BaseAutocomplete';
import DateTimePicker from '../../components/DateTimePicker';

const CreateNewJobModal = (props) => {
  const [formValues, setFormValues] = useState({
    // name: '',
    dealer: '',
    scheduled: '',
  });

  const [isShowDateTimePicker, setIsShowDateTimePicker] = useState(false);

  // const updateFields = (e) => {
  //   setFormValues({
  //     ...formValues,
  //     [e.target.name]: e.target.value
  //   });
  // }

  const submit = async (e) => {
    e.preventDefault();
    const dealer = props.dealerList.find(d => d.name === formValues.dealer);

    props.createNewJob({
      name: formValues.name,
      status: 'scheduled',
      barcode: '',
      dealerUUID: dealer.UUID,
      dealer: formValues.dealer,
      autoMake: dealer.brand,
      scheduledStartTime: formValues.scheduled,
      notes: '',
    }, (to) => props.history.push(`/jobs/${to}`));
  }

  const selectDealer = (prop, value) => {
    setFormValues({
      ...formValues,
      [prop]: value
    });
  }

  const choseDate = ({date, time}) => {
    setFormValues({
      ...formValues,
      scheduled: `${date} ${time}`
    });
    toggleDateTimePicker();
  }

  const toggleDateTimePicker = (e) => {
    setIsShowDateTimePicker(!isShowDateTimePicker);
  }

  const body = (
    <div className="create-new-job__body">
      <h2 className="create-new-job__title modal__body-title">
        New Job
      </h2>
      <form className="create-new-job__form form" onSubmit={submit}>
        {/* <div className="form__group">
          <label className="form__label" htmlFor="name">Job Name</label>
          <input className="form__input" id="name" type="text" value={formValues.name} name="name" onChange={updateFields}/>
        </div> */}
        <div className="form__group">
          <label className="form__label" htmlFor="dealer">Dealer</label>
          <BaseAutocomplete 
            className="create-new-job__autocomplete" 
            type="select" 
            selectOptions={props.selectOptions} 
            selectOption={selectDealer} 
            value={formValues[props.selectOptions.prop]}
            inputId="dealer"
            isShowSelectIcon={true}
            inputPlaceholder="Search Dealer"
          />
        </div>
        <div className="form__group">
          <label className="form__label" htmlFor="scheduled">Scheduled</label>
          <input className="form__input" readOnly type="text" id="scheduled" value={formValues.scheduled} name="scheduled" onFocus={toggleDateTimePicker}/>
        </div>
        <div className="form__group">
          <input 
            className="btn btn--primary" 
            type="submit" 
            value="Create" 
            onSubmit={submit} 
            disabled={!formValues.dealer || !formValues.scheduled}
          />
        </div>
      </form>
      {
        isShowDateTimePicker &&
        <DateTimePicker onChoseDate={choseDate} closeDateTimePicker={() => toggleDateTimePicker()}/>
      }
    </div>
  );

  return (
    <BaseModal body={body} footer={null} onClose={props.onClose}/>
  );
}

const mapStateToProps = ({dealers: {dealerList}}) => ({dealerList});

export default connect(mapStateToProps, { createNewJob })(withRouter(CreateNewJobModal));